// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-XRV54","footer__price":"footer__price-5TefD","price__from":"price__from-3MYvQ","footer__button":"footer__button-1zcBy","footer_selected":"footer_selected-fP6S8"};